export default __webpack_public_path__ + "static/media/NewDash.330ca0ca.svg";